var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6948 32.2251L42.4823 53.5401C42.5247 53.7911 42.4895 54.049 42.3814 54.2795C42.2732 54.5099 42.0973 54.7018 41.8771 54.8296C41.657 54.9573 41.403 55.0148 41.1493 54.9944C40.8956 54.9739 40.6542 54.8765 40.4573 54.7151L31.5073 47.9976C31.0752 47.6748 30.5504 47.5004 30.0111 47.5004C29.4717 47.5004 28.9469 47.6748 28.5148 47.9976L19.5498 54.7126C19.3531 54.8737 19.112 54.971 18.8585 54.9915C18.6051 55.0119 18.3515 54.9547 18.1315 54.8273C17.9114 54.6999 17.7355 54.5084 17.6271 54.2784C17.5187 54.0485 17.483 53.7909 17.5248 53.5401L21.3098 32.2251",
    stroke: "#744DFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 35C38.2843 35 45 28.2843 45 20C45 11.7157 38.2843 5 30 5C21.7157 5 15 11.7157 15 20C15 28.2843 21.7157 35 30 35Z",
    stroke: "#744DFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpert);
export default __webpack_public_path__ + "static/media/expert.6c23714bbebfee39690ff3800c082182.svg";
export { ForwardRef as ReactComponent };